import React, { memo, useState } from 'react'
import { Trans } from 'react-i18next'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { Button, Grid, Icon, Modal } from 'semantic-ui-react'
import useWindowDimensions from '../hooks/useWindowDimensions'
import { IconEduApp } from '../Icons'
import styles from '../styles'
import { theme } from '../../theme'

const DownloadButton = ({ onClick, text }) => {
  const { width } = useWindowDimensions()

  return (
    <Button color='blue' type='submit' style={width < 720 ? mobileButtonStyle : buttonStyle} onClick={onClick}>
      <div style={{ textAlign: 'center', width: '90%' }}>{text}</div>
      <Icon name='chevron right' />
    </Button>
  )
}

const buttonStyle = {
  height: '4.375rem',
  fontSize: '1.313rem',
  width: '47%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}

const mobileButtonStyle = {
  height: '3.7rem',
  fontSize: '0.85rem',
  width: '48%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}

const rowStyle = {
  ...styles.centerStyle,
  justifyContent: 'space-between'
}

export const DownloadApp = props => {
  const { trigger, showModal } = props
  const [open, setOpen] = useState(showModal)

  const history = useHistory()

  const closeHandler = () => {
    if (showModal) {
      history.push('/sphero/home')
    } else {
      setOpen(false)
    }
  }

  return (
    <Modal
      closeIcon
      onClose={closeHandler}
      onOpen={() => setOpen(true)}
      open={open}
      size='large'
      trigger={trigger}
    >
      <Modal.Header><Trans i18nKey='download.app.header'>Download the Sphero Edu app</Trans></Modal.Header>
      <Modal.Content style={{ ...styles.centerColumnStyle, justifyContent: 'space-between', minHeight: '32rem' }}>
        <IconEduApp style={{ height: '100px', width: '100px' }} />
        <p><Trans i18nKey='download.app.description1'>You will need to download the Sphero Edu app to drive and run these programs on your Sphero robots</Trans></p>
        <Grid style={{ width: '80%', backgroundColor: theme.dark.foreground }}>
          <Grid.Row style={rowStyle}>
            <DownloadButton onClick={() => window.open('https://apps.apple.com/us/app/sphero-sprk/id1017847674')} text={<Trans i18nKey='download.app.button.get_apps.ios'>iOS (App Store)</Trans>} />
            <DownloadButton onClick={() => window.open('https://apps.apple.com/us/app/sphero-edu/id1349872101?mt=12')} text={<Trans i18nKey='download.app.button.get_apps.mac'>macOS (App Store)</Trans>} />
          </Grid.Row>
          <Grid.Row style={rowStyle}>
            <DownloadButton onClick={() => window.open('https://play.google.com/store/apps/details?id=com.sphero.sprk&hl=en.')} text={<Trans i18nKey='download.app.button.get_apps.android'>Android and Chrome OS (Google Play)</Trans>} />
            <DownloadButton onClick={() => window.open('https://www.amazon.com/gp/product/B018WUVNUK')} text={<Trans i18nKey='download.app.button.get_apps.fire'>Fire OS (Amazon Appstore)</Trans>} />
          </Grid.Row>
          <Grid.Row style={{ ...rowStyle, marginBottom: '1rem' }}>
            <DownloadButton onClick={() => window.open('https://www.microsoft.com/en-us/p/sphero-edu/9n2796r62xlz?rtc=1&activetab=pivot:overviewtab')} text={<Trans i18nKey='download.app.button.get_apps.windows.microsoft'>Windows (Microsoft Store)</Trans>} />
            <DownloadButton onClick={() => window.open('https://sphero.cc/msix')} text={<Trans i18nKey='download.app.button.get_apps.windows.exe'>Windows (EXE and MSIX downloads)</Trans>} />
          </Grid.Row>
        </Grid>
        <p><Trans i18nKey='download.app.description2'>To learn more about Sphero Edu device compatibility, please review the device compatibility documentation</Trans></p>
        <DownloadButton onClick={() => window.open('https://support.sphero.com/article/3tzmrkc6lx-edu')} text={<Trans i18nKey='download.app.button.compatability'>Devince Compatability</Trans>} />
      </Modal.Content>
    </Modal>
  )
}

export default memo(DownloadApp)
